import React from "react"
import styled, { css } from "styled-components"
import Breakpoints from "../../components/shared/breakpoints"
import Chevron from "../../components/shared/svg/chevron"
import { desktopTextStyles } from "../../components/shared/typography.styles"
import BreakpointImage from "../atoms/breakpoint-image"
import { ButtonStyles } from "../atoms/button"
import Block from "../atoms/layout-primitives/block"
import Text, { T } from "../atoms/text"
import VariantContainer from "../atoms/variant-container"
import ContentBlock from "./content-block"

const OuterContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  text-decoration: none;

  :focus {
    outline: none;
  }

  @media (min-width: ${Breakpoints.lg}) {
    max-width: 422px;
  }
`

const Image = styled(BreakpointImage)`
  width: 100%;
  height: 164px;

  @media (min-width: ${Breakpoints.lg}) {
    height: 196px;
  }

  @supports (aspect-ratio: 16 / 9) {
    height: unset;
    aspect-ratio: 16 / 9;

    @media (min-width: ${Breakpoints.md}) {
      aspect-ratio: 598 / 192;
    }
    @media (min-width: ${Breakpoints.lg}) {
      aspect-ratio: 374 / 192;
    }
  }
`

const ContentContainer = styled.div`
  padding: 24px 28px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  @media (min-width: ${Breakpoints.md}) {
    padding: 32px;
  }

  @media (min-width: ${Breakpoints.lg}) {
    padding: 24px;
  }
`
interface IBlogCardBase {
  resourceName?: string
  title?: string
  description?: string
  link?: string
  className?: string
}

interface IResourceCardBreakpointImage extends IBlogCardBase {
  fluid?: never
  imageVariants: any
}
interface IResourceCardFluidImage extends IBlogCardBase {
  fluid: any
  imageVariants?: never
}

const ResourceCard = ({
  fluid,
  imageVariants,
  resourceName,
  title,
  description,
  link,
  className,
}: IResourceCardBreakpointImage | IResourceCardFluidImage) => {
  const linkProps = {
    href: link,
    target: "_blank",
    rel: "noreferrer",
  }

  return (
    <OuterContainer {...linkProps} className={className} as="a">
      {(fluid || imageVariants) && (
        <Image
          fluid={fluid}
          imageVariants={imageVariants}
          imgStyle={{ objectFit: "cover" }}
        />
      )}
      <ContentContainer>
        {resourceName && (
          <Text
            as="h3"
            variants={[
              css`
                ${desktopTextStyles.HeadingSixRegular}
                opacity: 0.5;
                color: var(--slate);
                text-align: center;
                margin-bottom: 8px;
              `,
            ]}
          >
            {resourceName}
          </Text>
        )}
        {/*@ts-ignore*/}
        <ContentBlock.ResourceCard title={title} description={description} />

        {link && (
          <Block display={{ sm: "none", lg: "block" }}>
            {/* 
              Using a VariantContainer to fake the button that was here before
              fixes the nested anchor tag console error
            */}
            <VariantContainer
              // @ts-ignore: Prop for ButtonStyles.TextLinkStyle
              $primary={"var(--burnt-orange)"}
              variants={[
                css`
                  display: inline-flex;
                  align-self: center;
                  justify-content: center;
                  text-align: center;
                  box-sizing: border-box;
                  cursor: pointer;
                  ${T.misc.link`500`};
                  ${ButtonStyles.TextLinkStyle}
                  margin: 24px auto 0;
                `,
              ]}
            >
              Read More <Chevron color={"var(--burnt-orange)"} />
            </VariantContainer>
          </Block>
        )}
      </ContentContainer>
    </OuterContainer>
  )
}

export default ResourceCard
